import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tab, Tabs } from 'react-bootstrap';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import CompanyDetailPage from './CompanyDetailPage';
import ErrorComponent from '../components/ErrorComponent';

export default class PersonDetailPage extends PageComponent {

  static PageInfo = {
    parent: CompanyDetailPage,
    hidden: true,

    path: "/Client/Detail/Person/:id",
    name: "menu.client", 
    permission: { "CONFIGURATION_USERS_ACCESSING": true },
    icon: "user"
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.modalError = null;
    this.state.company = null
    this.state.loading = true;
  }
  componentDidMount() {
    this.loadClients();
  }

  loadClients() {
    Connection.Secure(Connection.service + 'Person/Detail/' + this.data.id)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ loading: false, company: data });
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  render() {
    return (
      <Container context={this.constructor} props={this.data}>
        <div>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div className="generics_panels">
                  <div className="generics_panels_sizeless">
                    <div>
                      <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                      <div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("admin.company")}</div>
                          <div className="generics_infobox_value">{this.state.company.name}</div>
                        </div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("information." + this.state.company.mainKeyCriticalType.label)}</div>
                          <div className="generics_infobox_value">{this.state.company.criticalValue}</div>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("admin.company")}</div>
                          <div className="generics_infobox_value">{this.state.company.name}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="generics_panels_flex1">
                    <div style={{ height: 17 }}></div>
                    <Tabs
                      id="controlled-tab-example"
                      onSelect={(k) => this.changeTab(k)} >
                      <Tab eventKey="home" title="Address" />
                      <Tab eventKey="profile" title="Programs" />
                      <Tab eventKey="contact" title="Contact" />
                    </Tabs>
                  </div>
                </div>
          }
        </div>
      </Container>
    );
  }
}

